"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;
var Form = {
  controlLabelColor: '#132122',
  controlInputHeight: '52px',
  controlInputLineHeight: '20px',
  controlInputPadding: '15px',
  controlInputColor: '#063051',
  controlInputBorder: '1px solid #424d4e',
  controlInputBorderFocus: '1px solid #e8184c'
};
exports.Form = Form;